
/**
 * Menormalkan nomor telepon Indonesia menjadi format konsisten: 62xxxxxxxxxx
 * Menerima input: "081234...", "81234...", "6281234...", "+6281234..."
 */
export const normalizePhoneNumber = (phone: string | number): string => {
    // Buang semua karakter non-digit (spasi, +, strip, dll)
    let cleaned = String(phone).replace(/\D/g, "");

    if (!cleaned) return "";

    // Kalau sudah diawali '62', pakai apa adanya
    if (cleaned.startsWith("62")) {
        return cleaned;
    }

    // Kalau diawali '0' (format lokal umum: 081234...), buang '0' lalu tambahkan '62'
    if (cleaned.startsWith("0")) {
        return `62${cleaned.slice(1)}`;
    }

    // Kalau tidak diawali apa-apa (misal user input '81234...'), tambahkan '62' langsung
    return `62${cleaned}`;
};

/**
 * Kebalikannya: untuk DITAMPILKAN di form (tanpa prefix 62),
 * supaya konsisten dengan tampilan input yang sudah ada '+62' di depan field
 */
export const stripCountryCode = (phone: string | number): string => {
    let cleaned = String(phone).replace(/\D/g, "");
    if (cleaned.startsWith("62")) {
        return cleaned.slice(2);
    }
    if (cleaned.startsWith("0")) {
        return cleaned.slice(1);
    }
    return cleaned;
};